import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutPage() {
  const aboutJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于91叔叔',
    description: '91叔叔是深受用户喜爱的内容平台，致力于提供优质内容与精彩体验',
    url: 'https://www.91uncle.com/about',
  };

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '91叔叔',
    url: 'https://www.91uncle.com/',
    description: '91叔叔是深受用户喜爱的内容平台',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-9191',
      contactType: 'customer service',
      availableLanguage: 'Chinese',
      email: 'contact@91uncle.com',
    },
    sameAs: [
      'https://weibo.com/91uncle',
      'https://www.zhihu.com/org/91uncle',
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(aboutJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
      <Breadcrumb
        items={[
          { label: '首页', to: '/' },
          { label: '关于我们' },
        ]}
      />

      <section className="w-full px-4 md:px-6 py-14 bg-background-50">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
            关于91叔叔
          </h1>
          <p className="text-lg text-foreground-500 leading-relaxed mb-12">
            91叔叔是深受用户喜爱的内容平台，我们致力于提供优质内容、实用资源和精彩的用户体验。
          </p>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
            <div className="bg-background-100 rounded-xl p-6">
              <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-4">
                <i className="ri-eye-line text-xl text-primary-600"></i>
              </div>
              <h2 className="text-lg font-heading font-semibold text-foreground-900 mb-3">我们的愿景</h2>
              <p className="text-sm text-foreground-500 leading-relaxed">
                成为用户最信赖的内容平台，让每个人都能轻松获取有价值的信息，享受知识带来的乐趣与成长。
              </p>
            </div>
            <div className="bg-background-100 rounded-xl p-6">
              <div className="w-12 h-12 rounded-lg bg-accent-100 flex items-center justify-center mb-4">
                <i className="ri-focus-2-line text-xl text-accent-600"></i>
              </div>
              <h2 className="text-lg font-heading font-semibold text-foreground-900 mb-3">我们的使命</h2>
              <p className="text-sm text-foreground-500 leading-relaxed">
                通过精选内容、智能推荐和社区互动，连接用户与优质信息，打造高效、愉悦的内容消费体验。
              </p>
            </div>
            <div className="bg-background-100 rounded-xl p-6">
              <div className="w-12 h-12 rounded-lg bg-secondary-100 flex items-center justify-center mb-4">
                <i className="ri-shield-check-line text-xl text-secondary-600"></i>
              </div>
              <h2 className="text-lg font-heading font-semibold text-foreground-900 mb-3">品质承诺</h2>
              <p className="text-sm text-foreground-500 leading-relaxed">
                每一篇内容都经过严格审核，确保信息的准确性、实用性和可读性，为用户提供值得信赖的阅读体验。
              </p>
            </div>
            <div className="bg-background-100 rounded-xl p-6">
              <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-4">
                <i className="ri-user-heart-line text-xl text-primary-600"></i>
              </div>
              <h2 className="text-lg font-heading font-semibold text-foreground-900 mb-3">用户至上</h2>
              <p className="text-sm text-foreground-500 leading-relaxed">
                始终以用户需求为导向，持续优化产品体验，倾听用户反馈，让平台更好用、内容更好看、服务更贴心。
              </p>
            </div>
          </div>
        </div>
      </section>

      <section id="reputation" className="w-full px-4 md:px-6 py-16 bg-background-100">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-10 text-center">
            用户口碑
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              {
                name: '张先生',
                role: '资深用户 · 3年',
                comment: '91叔叔是我每天必看的内容平台，内容丰富、分类清晰，会员功能也非常实用，强烈推荐！',
                rating: 5,
              },
              {
                name: '李女士',
                role: '会员用户 · 1年',
                comment: '开通会员后体验提升了很多，无广告浏览和专属资源真的很值，客服响应也很快。',
                rating: 5,
              },
              {
                name: '王同学',
                role: '新用户 · 3个月',
                comment: '朋友推荐来的，界面简洁好用，资源推荐很精准，很快就找到了我需要的内容。',
                rating: 5,
              },
            ].map((r, idx) => (
              <div key={idx} className="bg-background-50 rounded-xl p-6 border border-background-200/70">
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: r.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm text-accent-500"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  "{r.comment}"
                </p>
                <div>
                  <div className="text-sm font-medium text-foreground-900">{r.name}</div>
                  <div className="text-xs text-foreground-400">{r.role}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="contact" className="w-full px-4 md:px-6 py-16 bg-background-50">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-10 text-center">
            联系我们
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
            <div className="lg:col-span-2 flex flex-col gap-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-mail-line text-lg text-primary-600"></i>
                </div>
                <div>
                  <h3 className="text-sm font-medium text-foreground-900 mb-1">电子邮箱</h3>
                  <p className="text-sm text-foreground-500">contact@91uncle.com</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-phone-line text-lg text-accent-600"></i>
                </div>
                <div>
                  <h3 className="text-sm font-medium text-foreground-900 mb-1">客服热线</h3>
                  <p className="text-sm text-foreground-500">400-888-9191</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-time-line text-lg text-secondary-600"></i>
                </div>
                <div>
                  <h3 className="text-sm font-medium text-foreground-900 mb-1">工作时间</h3>
                  <p className="text-sm text-foreground-500">周一至周日 9:00 - 21:00</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-lg text-primary-600"></i>
                </div>
                <div>
                  <h3 className="text-sm font-medium text-foreground-900 mb-1">公司地址</h3>
                  <p className="text-sm text-foreground-500">北京市朝阳区建国路88号SOHO现代城A座</p>
                </div>
              </div>
            </div>

            <div className="lg:col-span-3 bg-background-100 rounded-xl p-6">
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-5">
                发送消息
              </h3>
              <form
                id="about-contact-form"
                data-readdy-form=""
                action="https://readdy.ai/api/form/d9pmheeb4qjhggaeq180"
                method="POST"
                className="flex flex-col gap-4"
                onSubmit={(e) => {
                  e.preventDefault();
                  const form = e.currentTarget;
                  const honeypot = (form.querySelector('[name="company_alt"]') as HTMLInputElement)?.value?.trim();
                  if (honeypot) {
                    alert('消息已发送，我们会尽快回复！');
                    form.reset();
                    return;
                  }
                  const fd = new FormData(form);
                  const params = new URLSearchParams();
                  fd.forEach((value, key) => {
                    params.append(key, value as string);
                  });
                  const url = form.getAttribute('action') || '';
                  fetch(url, { method: 'POST', body: params.toString(), headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
                    .then(async (res) => {
                      const txt = await res.text();
                      let parsed: Record<string, unknown> = {};
                      try { parsed = JSON.parse(txt); } catch { /* ignore */ }
                      const msg = (parsed?.meta as Record<string, string>)?.message || (parsed?.message as string) || '';
                      if (res.ok && (parsed?.code === 'OK')) {
                        alert('感谢您的留言，我们会尽快回复！');
                        form.reset();
                      } else if (msg.toLowerCase().includes('spam')) {
                        alert('消息已发送，我们会尽快回复！');
                        form.reset();
                      } else {
                        alert(msg || '发送失败，请稍后再试');
                      }
                    })
                    .catch(() => alert('网络错误，请稍后重试'));
                }}
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="about-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      姓名 <span className="text-red-400">*</span>
                    </label>
                    <input
                      id="about-name"
                      name="name"
                      type="text"
                      required
                      className="w-full px-4 py-2.5 bg-background-50 border border-background-200 rounded-lg text-sm text-foreground-900 focus:outline-none focus:border-primary-300 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="about-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      邮箱 <span className="text-red-400">*</span>
                    </label>
                    <input
                      id="about-email"
                      name="email"
                      type="email"
                      required
                      className="w-full px-4 py-2.5 bg-background-50 border border-background-200 rounded-lg text-sm text-foreground-900 focus:outline-none focus:border-primary-300 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                </div>
                <div>
                  <label htmlFor="about-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    主题 <span className="text-red-400">*</span>
                  </label>
                  <input
                    id="about-subject"
                    name="subject"
                    type="text"
                    required
                    className="w-full px-4 py-2.5 bg-background-50 border border-background-200 rounded-lg text-sm text-foreground-900 focus:outline-none focus:border-primary-300 transition-colors"
                    placeholder="请输入消息主题"
                  />
                </div>
                <div>
                  <label htmlFor="about-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    留言内容 <span className="text-red-400">*</span>
                  </label>
                  <textarea
                    id="about-message"
                    name="message"
                    required
                    maxLength={500}
                    rows={4}
                    className="w-full px-4 py-2.5 bg-background-50 border border-background-200 rounded-lg text-sm text-foreground-900 focus:outline-none focus:border-primary-300 transition-colors resize-none"
                    placeholder="请输入您的留言（500字以内）"
                  ></textarea>
                </div>
                <input
                  type="text"
                  name="company_alt"
                  className="honeypot-field"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />
                <button
                  type="submit"
                  className="self-start px-8 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  发送消息
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}